export const tableFilters = tableKey => ({
  get: () => JSON.parse(sessionStorage.getItem(tableKey)) || {},
  set: value => sessionStorage.setItem(tableKey, JSON.stringify(value)),
});

export const currentUser = JSON.parse(localStorage.getItem('currentUser')) || {};

export const getCurrentUser = () => JSON.parse(localStorage.getItem('currentUser')) || { id: 0, publicSettings: {} };
